import TRASH_BOMB_IMAGE_URL from './trash.png';
export { TRASH_BOMB_IMAGE_URL };
export const TRASH_BOMB_SPRITESHEET_DATA = {
    frames: {
        'trash.png': {
            frame: { x: 1, y: 1, w: 156, h: 179 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 156, h: 179 },
            sourceSize: { w: 156, h: 179 },
            anchor: { x: 0.49359, y: 0.972067 }
        }
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.1',
        image: TRASH_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 158, h: 181 },
        scale: '0.3',
        smartupdate: '$TexturePacker:SmartUpdate:e3de1beef939d7a8deb59480823e3acf:964eac51ee16de624d06753d438853b3:fed2d4d826b5ccc56796f850839e5048$'
    }
};
